var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 5.11V10C9.75 11 9.5 11 8.25 11H3.75C2.5 11 2.25 11 2.25 10.25V5.11M2.5 1H9.5C10.5 1 11 0.999946 11 1.99995V4C11 5 10.5 5 9.5 5H2.5C1.5 5 1 5 1 4.25V1.75C1 0.999946 1.5 1 2.5 1ZM5.09 7H6.91H5.09Z",
    fill: "#EFF3F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 5.11V10C9.75 11 9.5 11 8.25 11H3.75C2.5 11 2.25 11 2.25 10.25V5.11M5.09 7H6.91M2.5 1H9.5C10.5 1 11 0.999946 11 1.99995V4C11 5 10.5 5 9.5 5H2.5C1.5 5 1 5 1 4.25V1.75C1 0.999946 1.5 1 2.5 1Z",
    stroke: "#071E31",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive-icon.71df58b3e3f2d9c3a5d2f49e69b550f5.svg";
export { ForwardRef as ReactComponent };